// import CustomButton from '@/common/CustomButton';
// import Layout from '@/common/Layout';
// import {
//   ArrowLeftOutlined,
//   EditOutlined,
//   PlusOutlined,
//   SearchOutlined
// } from '@ant-design/icons';
// import { cards } from '..';
// import CustomTable from '@/common/Table';
// import { columnRenderer, headerRenderer } from 'utilities/helpers';
// import { Button, Input, Switch, Tag, Tooltip } from 'antd';
// import { useCallback, useEffect, useState } from 'react';
// import CreateClientModal from '../components/CreateClientModal';
// import { useDispatch, useSelector } from 'react-redux';
// import { getAllClients, selectTaskSlice } from 'pages/Tasks/redux/slice';
// import { selectConfigureSlice } from '../redux/slice';
// import { debounce } from 'lodash';
// import { useNavigate } from 'react-router-dom';

// export default function Clients() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const dispatch = useDispatch();
//   const [clients, setClients] = useState([]);
//   const [Active, isActive] = useState(false);
//   const { loading } = useSelector(selectTaskSlice);
//   const navigate = useNavigate();

//   const handleGetAllClients = (search = '') => {
//     const payload = { search, type: 'all' };
//     dispatch(getAllClients(payload)).then((res) => {
//       if (res?.payload?.success) {
//         setClients(res?.payload?.data);
//       }
//     });
//   };

//   useEffect(() => {
//     handleGetAllClients('');
//   }, []);

//   const columns = [
//     {
//       title: headerRenderer('Client Name'),
//       dataIndex: 'client_name',
//       key: 'client_name',
//       width: '85%',
//       render: (text, record) =>
//         columnRenderer(
//           <div className="flex items-center gap-4">
//             <label>{text}</label>
//             {!record.is_active ? (
//               <Tag color="error" className="!text-[8px]">
//                 Deactivated
//               </Tag>
//             ) : null}
//           </div>
//         )
//     },
//     {
//       title: headerRenderer('Action'),
//       dataIndex: 'action',
//       key: 'action',
//       width: '15%',
//       render: (text, record) => (
//         <div className="grid grid-cols-4 gap-4 place-items-center">
//           <Tooltip title="Edit" overlayClassName="!text-xs">
//             <EditOutlined
//               onClick={() => setIsModalOpen(record.id)}
//               className="text-lg cursor-pointer text-[#0653fa] hover:!scale-105 "
//             />
//           </Tooltip>
//         </div>
//       )
//     }
//   ];

//   const dataSource = clients.length
//     ? clients.map((client) => {
//         return {
//           client_name: client.client_name,
//           id: client.id,
//           is_active: client.is_active,
//           client
//         };
//       })
//     : [];

//   const debouncedSearch = useCallback(
//     debounce((value) => {
//       handleGetAllClients(value);
//     }, 300),
//     []
//   );

//   return (
//     <Layout>
//       <div className="flex flex-col gap-2 md:gap-6">
//         <div className="flex justify-end md:hidden">
//           <CustomButton type="outlined" onClick={() => navigate('/configure')}>
//             <ArrowLeftOutlined /> Back to Settings
//           </CustomButton>
//         </div>

//         <div className="flex flex-col items-start justify-between md:items-center md:flex-row">
//           <div className="flex flex-col gap-1">
//             <label className={'!text-xl md:!text-3xl !font-bold md:mt-0 mt-2'}>
//               Clients
//             </label>
//             <p className="!text-gray-500 text-balance text-xs md:text-sm !font-semibold">
//               {cards[0].description}
//             </p>
//           </div>

//           <div className="items-center hidden gap-4 md:flex">
//             <Input
//               placeholder="Search client"
//               prefix={<SearchOutlined style={{ color: '#00000072' }} />}
//               allowClear
//               className="!w-52"
//               onChange={(e) => debouncedSearch(e.target.value)}
//             />
//             <CustomButton
//               icon={<PlusOutlined />}
//               className={'!text-sm rounded-md hidden md:block'}
//               type="primary"
//               onClick={() => setIsModalOpen(true)}
//             >
//               Add Client
//             </CustomButton>
//             <CustomButton
//               type="outlined"
//               onClick={() => navigate('/configure')}
//             >
//               <ArrowLeftOutlined /> Back to Settings
//             </CustomButton>
//           </div>
//           <div className="flex items-center gap-4 md:hidden">
//             <Input
//               placeholder="Search client"
//               prefix={<SearchOutlined style={{ color: '#00000072' }} />}
//               allowClear
//               className="!w-auto"
//               onChange={(e) => debouncedSearch(e.target.value)}
//             />
//             <CustomButton
//               icon={<PlusOutlined />}
//               className={'!text-sm rounded-md block md:hidden'}
//               type="primary"
//               onClick={() => setIsModalOpen(true)}
//             >
//               Add Client
//             </CustomButton>
//           </div>
//         </div>

//         <div className="flex justify-end pr-[115px]">
//           <div
//             className="flex items-center w-fit h-8 gap-2 px-4 bg-white rounded-md"
//             style={{ border: '1px solid rgb(220, 220, 228)' }}
//           >
//             <span
//               className={
//                 !Active ? 'font-semibold text-[#0653fa]' : 'text-gray-500'
//               }
//             >
//               Active
//             </span>
//             <Switch
//               checked={Active}
//               size="small"
//               onChange={(checked) => isActive(checked)}
//             />
//             <span
//               className={
//                 Active ? 'font-semibold text-blue-600' : 'text-gray-500'
//               }
//             >
//               All
//             </span>
//           </div>
//         </div>
//         {/* table */}
//         <CustomTable
//           columns={columns}
//           dataSource={dataSource}
//           pagination={false}
//           loading={loading}
//           onChange={() => {}}
//           classname={'!min-w-fit'}
//           emptyText={'No clients to show'}
//         />

//         {/* modal */}
//         <CreateClientModal
//           isOpen={isModalOpen}
//           setIsOpen={setIsModalOpen}
//           name={'Client'}
//           onAssign={handleGetAllClients}
//           data={clients.find((client) => client.id === isModalOpen)}
//         />
//       </div>
//     </Layout>
//   );
// }

import CustomButton from '@/common/CustomButton';
import Layout from '@/common/Layout';
import {
  ArrowLeftOutlined,
  EditOutlined,
  PlusOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { cards } from '..';
import CustomTable from '@/common/Table';
import { columnRenderer, headerRenderer } from 'utilities/helpers';
import { Button, Input, Switch, Tag, Tooltip } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import CreateClientModal from '../components/CreateClientModal';
import { useDispatch, useSelector } from 'react-redux';
import { getAllClients, selectTaskSlice } from 'pages/Tasks/redux/slice';
import { selectConfigureSlice } from '../redux/slice';
import { debounce } from 'lodash';
import { useNavigate } from 'react-router-dom';

export default function Clients() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [clients, setClients] = useState([]);
  const [allClients, setAllClients] = useState([]);
  const [Active, isActive] = useState(false);
  const { loading } = useSelector(selectTaskSlice);
  const navigate = useNavigate();

  // const handleGetAllClients = (search = '') => {
  //   const payload = { search, type: 'all' };
  //   dispatch(getAllClients(payload)).then((res) => {
  //     if (res?.payload?.success) {
  //       setClients(res?.payload?.data);
  //     }
  //   });
  // };

  const handleGetAllClients = (search = '') => {
    const payload = { search, type: 'all' }; // or remove 'type' if unnecessary
    dispatch(getAllClients(payload)).then((res) => {
      if (res?.payload?.success) {
        setAllClients(res.payload.data);
      }
    });
  };

  useEffect(() => {
    handleGetAllClients('');
  }, []);

  useEffect(() => {
    if (!Active) {
      setClients(allClients.filter((c) => c.is_active));
    } else {
      setClients(allClients);
    }
  }, [Active, allClients]);

  const columns = [
    {
      title: headerRenderer('Client Name'),
      dataIndex: 'client_name',
      key: 'client_name',
      width: '85%',
      render: (text, record) =>
        columnRenderer(
          <div className="flex items-center gap-4">
            <label>{text}</label>
            {!record.is_active ? (
              <Tag color="error" className="!text-[8px]">
                Deactivated
              </Tag>
            ) : null}
          </div>
        )
    },
    {
      title: headerRenderer('Action'),
      dataIndex: 'action',
      key: 'action',
      width: '15%',
      render: (text, record) => (
        <div className="grid grid-cols-4 gap-4 place-items-center">
          <Tooltip title="Edit" overlayClassName="!text-xs">
            <EditOutlined
              onClick={() => setIsModalOpen(record.id)}
              className="text-lg cursor-pointer text-[#0653fa] hover:!scale-105 "
            />
          </Tooltip>
        </div>
      )
    }
  ];

  const dataSource = clients.length
    ? clients.map((client) => {
        return {
          client_name: client.client_name,
          id: client.id,
          is_active: client.is_active,
          client
        };
      })
    : [];

  // const debouncedSearch = useCallback(
  //   debounce((value) => {
  //     handleGetAllClients(value);
  //   }, 300),
  //   []
  // );

  const debouncedSearch = useCallback(
    debounce((value) => {
      const filtered = allClients.filter((c) => {
        const matchesSearch = c.client_name
          .toLowerCase()
          .includes(value.toLowerCase());
        const matchesStatus = Active ? c.is_active : true;
        return matchesSearch && matchesStatus;
      });
      setClients(filtered);
    }, 300),
    [Active, allClients]
  );

  return (
    <Layout>
      <div className="flex flex-col gap-2 md:gap-6">
        <div className="flex justify-end md:hidden">
          <CustomButton type="outlined" onClick={() => navigate('/configure')}>
            <ArrowLeftOutlined /> Back to Settings
          </CustomButton>
        </div>

        <div className="flex flex-col items-start justify-between md:items-center md:flex-row">
          <div className="flex flex-col gap-1">
            <label className={'!text-xl md:!text-3xl !font-bold md:mt-0 mt-2'}>
              Clients
            </label>
            <p className="!text-gray-500 text-balance text-xs md:text-sm !font-semibold">
              {cards[0].description}
            </p>
          </div>

          <div className="items-center hidden gap-4 md:flex">
            <Input
              placeholder="Search client"
              prefix={<SearchOutlined style={{ color: '#00000072' }} />}
              allowClear
              className="!w-52"
              onChange={(e) => debouncedSearch(e.target.value)}
            />
            <CustomButton
              icon={<PlusOutlined />}
              className={'!text-sm rounded-md hidden md:block'}
              type="primary"
              onClick={() => setIsModalOpen(true)}
            >
              Add Client
            </CustomButton>
            <CustomButton
              type="outlined"
              onClick={() => navigate('/configure')}
            >
              <ArrowLeftOutlined /> Back to Settings
            </CustomButton>
          </div>
          <div className="flex items-center gap-4 md:hidden">
            <Input
              placeholder="Search client"
              prefix={<SearchOutlined style={{ color: '#00000072' }} />}
              allowClear
              className="!w-auto"
              onChange={(e) => debouncedSearch(e.target.value)}
            />
            <CustomButton
              icon={<PlusOutlined />}
              className={'!text-sm rounded-md block md:hidden'}
              type="primary"
              onClick={() => setIsModalOpen(true)}
            >
              Add Client
            </CustomButton>
          </div>
        </div>

        <div className="flex justify-end ">
          <div
            className="flex items-center w-fit h-8 gap-2 px-4 bg-white rounded-md"
            style={{ border: '1px solid rgb(220, 220, 228)' }}
          >
            <span
              className={
                !Active ? 'font-semibold text-[#0653fa]' : 'text-gray-500'
              }
            >
              Active
            </span>
            <Switch
              checked={Active}
              size="small"
              onChange={(checked) => isActive(checked)}
            />
            <span
              className={
                Active ? 'font-semibold text-blue-600' : 'text-gray-500'
              }
            >
              All
            </span>
          </div>
        </div>
        {/* table */}
        <CustomTable
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          loading={loading}
          onChange={() => {}}
          classname={'!min-w-fit'}
          emptyText={'No clients to show'}
        />

        {/* modal */}
        <CreateClientModal
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          name={'Client'}
          onAssign={handleGetAllClients}
          data={clients.find((client) => client.id === isModalOpen)}
        />
      </div>
    </Layout>
  );
}
